import AddQuestionnaireQuestionContainer from "./AddQuestionnaireQuestionContainer";

export default AddQuestionnaireQuestionContainer;
